var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeadsWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3799_7159)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M4.0625 13C4.0625 9.63452 6.79077 6.90625 10.1562 6.90625H7.10938C3.7439 6.90625 1.01562 9.63452 1.01562 13C1.01562 16.3655 3.7439 19.0938 7.10938 19.0938H10.1562C6.79077 19.0938 4.0625 16.3655 4.0625 13Z",
    fill: "url(#paint0_linear_3799_7159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9219 5.07812C22.0437 5.07812 22.9531 4.1687 22.9531 3.04688C22.9531 1.92505 22.0437 1.01562 20.9219 1.01562C19.8 1.01562 18.8906 1.92505 18.8906 3.04688C18.8906 4.1687 19.8 5.07812 20.9219 5.07812Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8594 11.1719C16.8594 8.92821 18.6782 7.10938 20.9219 7.10938C23.1655 7.10938 24.9844 8.92821 24.9844 11.1719",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8594 24.9844C16.8594 22.7407 18.6782 20.9219 20.9219 20.9219C23.1655 20.9219 24.9844 22.7407 24.9844 24.9844M10.7656 6.90625H7.10938C3.7439 6.90625 1.01562 9.63452 1.01562 13C1.01562 16.3655 3.7439 19.0938 7.10938 19.0938H10.7656C11.8874 19.0938 12.7969 18.1843 12.7969 17.0625C12.7969 15.9407 11.8874 15.0312 10.7656 15.0312H7.10938C5.98757 15.0312 5.07812 14.1218 5.07812 13C5.07812 11.8782 5.98757 10.9688 7.10938 10.9688H10.7656C11.8874 10.9688 12.7969 10.0593 12.7969 8.9375C12.7969 7.81569 11.8874 6.90625 10.7656 6.90625ZM22.9531 16.8594C22.9531 17.9812 22.0437 18.8906 20.9219 18.8906C19.8 18.8906 18.8906 17.9812 18.8906 16.8594C18.8906 15.7375 19.8 14.8281 20.9219 14.8281C22.0437 14.8281 22.9531 15.7375 22.9531 16.8594Z",
    stroke: "url(#paint1_linear_3799_7159)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3799_7159",
    x1: 1.01562,
    y1: 6.90625,
    x2: 11.5303,
    y2: 17.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3799_7159",
    x1: 1.44445,
    y1: 4.87354,
    x2: 21.9052,
    y2: 30.3109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3799_7159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadsWhite);
export default __webpack_public_path__ + "static/media/leadsWhite.73898bf9b3981c0145699ec62268081d.svg";
export { ForwardRef as ReactComponent };